export default __webpack_public_path__ + "static/media/radio-tower.1582b02a.svg";